import { AxiosResponse } from "axios";

export function apiResponse<TResult>(promise: Promise<AxiosResponse<TResult>>): Promise<TResult> {
  return promise
    .then(res => res.data)
    .catch(err => {
      console.log(err);
      throw new Error(err.response?.data?.message || 'An internal error occurred');
    });
}